/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { largerDependencies } from './dependenciesLarger.generated';
import { largerEqDependencies } from './dependenciesLargerEq.generated';
import { smallerDependencies } from './dependenciesSmaller.generated';
import { smallerEqDependencies } from './dependenciesSmallerEq.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createRange } from '../../factoriesAny.js';
export var rangeDependencies = {
  bignumberDependencies: bignumberDependencies,
  matrixDependencies: matrixDependencies,
  largerDependencies: largerDependencies,
  largerEqDependencies: largerEqDependencies,
  smallerDependencies: smallerDependencies,
  smallerEqDependencies: smallerEqDependencies,
  typedDependencies: typedDependencies,
  createRange: createRange
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRange.generated.js
// module id = 170
// module chunks = 0